export const baseUrl = 'https://api.themoviedb.org/3';
export const API_KEY = process.env.REACT_APP_API
export const imageUrl = 'https://image.tmdb.org/t/p/original'

//'962b0ed90c1adfc9dd04c26071c59c4c'